export const validId = value => typeof value === 'string' && /^[a-zA-Z0-9_-]{8,80}$/.test(value);
export const pendingKey = userId => `pb_coinflip_pending:${userId}`;
export function cents(value) {
  const text = String(value).trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(text) || text.length > 14) return null;
  const [whole, fraction = ''] = text.split('.');
  const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(amount) ? amount : null;
}
export const validBet = value => cents(value) != null && cents(value) >= 100 && cents(value) <= 100000;
export const validPending = value => value && validId(value.request_id) && Number.isFinite(value.bet) && validBet(value.bet) && ['heads', 'tails'].includes(value.choice) && ['coins', 'cash', 'bonus'].includes(value.currency);
export const multiplierFor = edgePct => Number.isFinite(edgePct) && edgePct >= 0 && edgePct <= 50 ? 2 * (1 - edgePct / 100) : null;
export function returnFor(bet, multiplier) {
  if (!validBet(bet) || !Number.isFinite(multiplier) || multiplier < 1 || multiplier > 2) return null;
  return Math.floor(cents(bet) * multiplier + .50000001) / 100;
}
export function cleanBalances(value) {
  if (!value || ['coins', 'cash', 'bonus'].some(cur => !Number.isFinite(value[cur]) || value[cur] < 0)) throw new Error('Invalid wallet response');
  return { coins: value.coins, cash: value.cash, bonus: value.bonus };
}
export function confirmedFlip(value) {
  if (!validPending(value) || value.status !== 'completed' || !['heads', 'tails'].includes(value.outcome) ||
      typeof value.win !== 'boolean' || value.win !== (value.choice === value.outcome) || value.chance !== 50 ||
      multiplierFor(value.edge_pct) == null || !Number.isFinite(value.multiplier) || Math.abs(value.multiplier - multiplierFor(value.edge_pct)) > 1e-8 ||
      !Number.isFinite(value.payout) || value.payout < 0 || (value.win ? Math.abs(value.payout - returnFor(value.bet, value.multiplier)) > .005 : value.payout !== 0)) throw new Error('Unconfirmed flip response');
  return { ...value, ...(value.balances ? { balances: cleanBalances(value.balances) } : {}) };
}
